/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Display type for an item level question
 */
export enum QuestionDisplayType {
    BUTTONS = 'buttons',
    DROPDOWN = 'dropdown',
}
